import type { Variants } from 'framer-motion';

import { defaultEase } from '../motion/MotionVariants';

export const menuVariants: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      ease: 'linear',
      duration: 0.1,
      delay: 1,
    },
    transitionEnd: {
      display: 'none',
    },
  },
  visible: {
    opacity: 1,
    transition: {
      ease: 'linear',
      duration: 0.1,
    },
    display: 'block',
  },
};

export const backdropVariants: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      ease: defaultEase,
      delay: 0.3,
      duration: 0.2,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      ease: defaultEase,
      duration: 0.2,
    },
  },
};

export const boxVariants: Variants = {
  hidden: {
    x: '100%',
    transition: {
      ease: defaultEase,
      duration: 0.5,
    },
  },
  visible: {
    x: 0,
    transition: {
      ease: defaultEase,
      duration: 0.5,
    },
  },
};

export const navList: Variants = {
  hidden: {
    opacity: 0,
    x: 64,
    transition: {
      duration: 0.4,
      staggerChildren: 0.05,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      staggerChildren: 0.05,
    },
  },
};

export const ctaVariant: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      ease: 'linear',
      duration: 0.3,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      ease: 'linear',
      delay: 0.3,
      duration: 0.3,
    },
  },
};
